import { useEffect, useRef } from 'react';

const DEFAULT_TICKET_TYPE = 'bug';

const useTicketAssigneeDefault = ({
  form,
  ticketType,
  isNewTicket,
  responsibleUserInfo,
  defaultBugAssigneeInfo,
  buildLabel,
}) => {
  const assigneeManuallyChosenRef = useRef(false);

  const resolveAssignee = (type) => {
    if (type === 'bug' && defaultBugAssigneeInfo?.id) {
      return defaultBugAssigneeInfo;
    }
    return responsibleUserInfo;
  };

  const initialAssignee = resolveAssignee(DEFAULT_TICKET_TYPE);

  useEffect(() => {
    if (!isNewTicket || assigneeManuallyChosenRef.current || !ticketType) return;

    const assignee = resolveAssignee(ticketType);
    if (!assignee?.id) return;

    /* eslint-disable camelcase */
    form.setFieldsValue({
      assignee_id: {
        value: assignee.id,
        label: buildLabel(assignee.username, assignee.avatarUrl),
      },
      assignee_type: assignee.type,
    });
    /* eslint-enable camelcase */
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticketType, isNewTicket]);

  const handleAssigneeChange = (_value, option) => {
    const selectedOption = Array.isArray(option) ? option[0] : option;

    assigneeManuallyChosenRef.current = true;
    /* eslint-disable-next-line camelcase */
    form.setFieldsValue({ assignee_type: selectedOption?.user_type });
  };

  const resetAssigneeChoice = () => {
    assigneeManuallyChosenRef.current = false;
  };

  return { initialAssignee, handleAssigneeChange, resetAssigneeChoice };
};

export default useTicketAssigneeDefault;
